import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styled from "styled-components";
import chroma from "chroma-js";

import { colors, FromTopPage, GridWrapper, Button } from "../theme";
import LoginForm from "../components/LoginForm";
import PasswordRequestModal from "../components/password/PasswordRequestModal";
import PasswordResetModal from "../components/password/PasswordResetModal";
import bgMLetterBottom from "../assets/bg-mletter-header.png";
import bgMLetterTop from "../assets/bg-mletter-header-top.svg";

const Container = styled(FromTopPage)`
  background: url(${bgMLetterTop}) top right, url(${bgMLetterBottom});
  background-repeat: no-repeat;
  background-size: auto, 100% 315px;
  padding: 70px 0;
  text-align: center;

  @media (max-width: 1023px) {
    padding: 35px 0 70px;
  }

  h1 {
    color: black;
    font-size: 4.8rem;
    font-weight: 100;
    letter-spacing: -0.06rem;
    line-height: 56px;
    margin-bottom: 46px;
    text-transform: uppercase;

    @media (max-width: 1023px) {
      font-size: 3.8rem;
    }

    @media (max-width: 767px) {
      font-size: 1.9rem;
      line-height: 32px;
      margin-bottom: 28px;
    }

    strong {
      display: block;
      font-size: 6.4rem;
      font-weight: 700;
      letter-spacing: 0.26rem;

      @media (max-width: 1023px) {
        font-size: 5.4rem;
      }

      @media (max-width: 767px) {
        font-size: 2.3rem;
      }
    }
  }
`;

const Main = styled(GridWrapper)`
  align-items: center;
  background: white;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  max-width: 890px;
  position: relative;
  z-index: 1;

  @media (max-width: 1023px) {
    display: block;
  }

  section {
    padding: 50px 80px;
    width: 50%;

    @media (max-width: 1023px) {
      width: auto;
    }

    @media (max-width: 767px) {
      padding: 30px 20px;
    }

    :first-child {
      border-right: 1px solid ${chroma(colors.purple).alpha(0.3)};

      @media (max-width: 1023px) {
        border: 0;
        border-bottom: 1px solid ${chroma(colors.purple).alpha(0.3)};
      }

      form > div:last-child {
        margin-top: 45px;

        @media (max-width: 767px) {
          margin-top: 35px;
        }

        a {
          color: ${colors.purple};
          font-weight: 500;
          margin-left: 20px;
          text-decoration: none;
          transition: 0.3s;

          &:hover {
            color: ${colors.red};
          }

          @media (max-width: 767px) {
            margin-left: 0;
            margin-top: 25px;
            display: block;
          }
        }
      }
    }
  }

  h2 {
    color: black;
    font-weight: 500;
    font-size: 2.8rem;
    letter-spacing: -0.02rem;
    margin-bottom: 35px;
    text-transform: uppercase;

    @media (max-width: 1023px) {
      font-size: 2rem;
      margin-bottom: 25px;
    }
  }

  h2 + p {
    font-size: 1.8rem;
    line-height: 2.4rem;
    margin-bottom: 35px;

    @media (max-width: 1023px) {
      font-size: 1.5rem;
    }
  }
`;

function Login({ location }) {
  const modalState = location.state && location.state.modal;
  let modal;
  switch (modalState) {
    case "REQUEST_PASSWORD":
      modal = <PasswordRequestModal />;
      break;
    case "RESET_PASSWORD":
      modal = <PasswordResetModal />;
      break;
    default:
      break;
  }

  return (
    <Container>
      {modal}
      <h1>
        Accédez à notre espace commun, <strong>connectez-vous !</strong>
      </h1>
      <Main>
        <LoginForm redirectionPath="/compte" />
        <section>
          <h2>Pas encore inscrit ?</h2>
          <p>
            Soutenez un Média indépendant
            et&nbsp;rejoignez&nbsp;notre&nbsp;communauté.
          </p>
          <Button as={Link} to="/soutien">
            Devenez Socio !
          </Button>
        </section>
      </Main>
    </Container>
  );
}

Login.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      modal: PropTypes.string,
    }),
  }).isRequired,
};

export default Login;
